module.exports = __webpack_public_path__ + "static/media/mywebgraphicdesign-logo.eaafbbda.svg";